export const CustomInput = ({ 
    name,
    className,
    register,
    label,
    labelClassName,
    placeholder,
    readOnly = false,
    type = "text",
    hrtag = false,
    value }) => {
    return (
        <div className="form-floating">
            <input
                type={type}
                className={className}
                name={name}
                // {...register(name, { required: false })}
                id={name}
                placeholder={placeholder}
                value={value}
                readOnly={readOnly}
            />
            <label className={`${labelClassName}`} htmlFor={name}>
                {label}
            </label>

            {hrtag ?

                <hr className={hrtag} />

                : null}


        </div>
    )
}
